import type { TFunction } from "i18next";
import { z } from "zod";

export const accessControlFormSchema = (t: TFunction) =>
  z.object({
    role: z.string(t("role_required")).min(1, {
      message: t("role_required"),
    }),
    company: z.string(t("company_required")).min(1, {
      message: t("company_required"),
    }),
  });

export type AccessControlFormSchemaValues = z.infer<
  ReturnType<typeof accessControlFormSchema>
>;
